export default __webpack_public_path__ + "static/media/emptymsg.f3806602.svg";